@if (projectPermissionReport$ | async; as permissionReport) { @if (projectId$ |
async; as projectId) {
<app-page pageTitle="Membership">
  @if (permissionReport.project.invite) {
  <div fxLayoutAlign="end" fxLayout="row" class="actions">
    <button
      mat-raised-button
      color="primary"
      (click)="inviteNewMembers()"
      class="invite-button"
    >
      <span class="material-icons">person_add</span> Invite New Members
    </button>
  </div>
  } @if (permissionReport.project.editMemberships) {
  <app-membership-table
    title="Current Members"
    singularItemName="member"
    pluralItemName="members"
    [members]="(members$ | async) ?? []"
    [showAvatar]="true"
  >
    <p *appTableSubtext="let count; let cn = collectiveName">
      There {{ count === 1 ? 'is' : 'are' }} currently
      <strong>{{ count }} member{{ count === 1 ? '' : 's' }}</strong> in your
      project.
    </p>
    <ng-container *appSelectedItemsActions="let selectedMemberIds">
      <button
        mat-menu-item
        (click)="
          updateSelectedMembers({
            selectedMemberIds,
            administrator: true
          })
        "
      >
        Make selected administrators...
      </button>
      <button
        mat-menu-item
        (click)="
          updateSelectedMembers({
            selectedMemberIds,
            administrator: false
          })
        "
      >
        Make selected reviewers...
      </button>
    </ng-container>
    <button
      mat-stroked-button
      *appItemAction="let member"
      [routerLink]="[
        '/projects',
        projectId,
        'admin',
        'membership',
        'members',
        member.tableId
      ]"
    >
      <div fxLayout="row">View Membership</div>
    </button>
  </app-membership-table>
  } @if (permissionReport.project.invite) {
  <app-membership-table
    title="Pending Invitations"
    singularItemName="invitation"
    pluralItemName="invitations"
    [members]="(invitations$ | async) ?? []"
    [showName]="false"
    [showEmail]="true"
  >
    <p *appTableSubtext="let count; let cn = collectiveName">
      There {{ count === 1 ? 'is' : 'are' }} currently
      <strong>{{ count }} {{ cn }}</strong> pending. Once a user accepts an
      invitation they will become a member of your project.
    </p>
    <ng-container *appSelectedItemsActions="let selectedInvitationIds">
      <button
        mat-menu-item
        (click)="revokeSelectedInvitations(selectedInvitationIds)"
      >
        Revoke selected...
      </button>
      <button
        mat-menu-item
        (click)="
          updateSelectedInvitations({
            selectedInvitationIds,
            administrator: true
          })
        "
      >
        Make selected administrators...
      </button>
      <button
        mat-menu-item
        (click)="
          updateSelectedInvitations({
            selectedInvitationIds,
            administrator: false
          })
        "
      >
        Make selected reviewers...
      </button>
    </ng-container>
    <button
      mat-stroked-button
      *appItemAction="let invitation"
      [routerLink]="[
        '/projects',
        projectId,
        'admin',
        'membership',
        'invitations',
        invitation.tableId
      ]"
    >
      <div fxLayout="row">View Invitation</div>
    </button>
  </app-membership-table>
  } @if (permissionReport.project.invite) {
  <app-membership-table
    title="Join Requests"
    singularItemName="join request"
    pluralItemName="join requests"
    [members]="(joinRequests$ | async) ?? []"
    [showAvatar]="true"
    [showGroup]="false"
  >
    <p *appTableSubtext="let count; let cn = collectiveName">
      There {{ count === 1 ? 'is' : 'are' }} currently
      <strong>{{ count }} user{{ count === 1 ? '' : 's' }}</strong>
      {{ count === 1 ? 'is' : 'are' }} who
      {{ count === 1 ? 'has' : 'have' }} requested to join this project.{{
        count === 1 ? '' : ' View a join request to accept/decline the request.'
      }}
    </p>
    <ng-container *appSelectedItemsActions="let selectedJoinRequestIds">
      <button
        mat-menu-item
        (click)="
          respondSelectedJoinRequests({
            ids: selectedJoinRequestIds,
            approve: true
          })
        "
      >
        Approve selected...
      </button>
      <button
        mat-menu-item
        (click)="
          respondSelectedJoinRequests({
            ids: selectedJoinRequestIds,
            approve: false
          })
        "
      >
        Decline selected...
      </button>
    </ng-container>
    <button
      mat-stroked-button
      *appItemAction="let joinRequest"
      [routerLink]="[
        '/projects',
        projectId,
        'admin',
        'membership',
        'join-requests',
        joinRequest.tableId
      ]"
    >
      <div fxLayout="row">View Join Request</div>
    </button>
  </app-membership-table>
  }
</app-page>
} }
